export enum ConvocatedStatus {
    CONVOCATORIA_GENERADA = 1,
    PENDIENTE_CAMBIOS = 2,
    RESULTADOS_GENERADOS = 3
}

export const CONVOCATED_STATUS_OPTIONS = [
    { id: ConvocatedStatus.CONVOCATORIA_GENERADA, nombre: 'Convocatoria generada' },
    { id: ConvocatedStatus.PENDIENTE_CAMBIOS, nombre: 'Pendiente de cambios' },
    { id: ConvocatedStatus.RESULTADOS_GENERADOS, nombre: 'Resultados generados' }
];

export const getConvocatedStatusLabel = (state: number): string => {
    const match = CONVOCATED_STATUS_OPTIONS.find((option) => option.id === state);
    return match?.nombre || '-';
};
